<div class="mainDiv"><span
        style="background-color:lightgrey;padding:5px;left:5px;margin-top:-15px;">{{dialogTitle}}</span>
    <p>&nbsp;</p>
    <ng-container *ngIf="bShowConfirmButton">
        <button id="btnConfirm" mat-raised-button [mat-dialog-close]="dialogResult" (click)="fnConfirm()">{{confirmButtonText}}</button>
    </ng-container>
    &nbsp;&nbsp;
    <ng-container *ngIf="bShowCancelButton">
        <button id="btnCancel" mat-raised-button (click)="fnCancel()">{{cancelButtonText}}</button><p>&nbsp;</p>
    </ng-container>
    <!-- <div class="row1">&nbsp;</div> -->
</div>